import React from 'react';
import {
    Box,
    Typography,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
} from '@mui/material';

const secondsToTime = (seconds) => {
    if (seconds === null || seconds === undefined) return '-';
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    return `${String(hrs).padStart(2, '0')}:${String(mins).padStart(2, '0')}`;
};

function PayoutSelectionTable({ payouts, selectedPayoutId, rowPercentages, onSelectPayout, onPercentageChange, onAdd, editingIndex, loading }) {
    if (!payouts) return null;
    if (payouts.length === 0) {
        return (
            <Typography variant="body2" color="textSecondary" sx={{ textAlign: 'center', py: 2, border: '1px solid rgba(217,217,217,1)', borderRadius: '8px', mt: 1 }}>
                No available driver payouts for the selected car type.
            </Typography>
        );
    }
    return (
        <Box sx={{ mt: 2, overflowX: 'auto' }}>
            <Table size="small" sx={{ border: '1px solid rgba(217,217,217,1)', borderRadius: '8px', minWidth: 700 }}>
                <TableHead>
                    <TableRow sx={{ bgcolor: 'rgba(225,244,228,1)' }}>
                        <TableCell sx={{ fontWeight: 'bold', width: 48 }} />
                        <TableCell sx={{ fontWeight: 'bold' }}>Payout Name</TableCell>
                        <TableCell sx={{ fontWeight: 'bold' }}>Time From</TableCell>
                        <TableCell sx={{ fontWeight: 'bold' }}>Time To</TableCell>
                        <TableCell sx={{ fontWeight: 'bold' }}>Initial Dist.</TableCell>
                        <TableCell sx={{ fontWeight: 'bold' }}>Initial Charge</TableCell>
                        <TableCell sx={{ fontWeight: 'bold' }}>Per Km</TableCell>
                        <TableCell sx={{ fontWeight: 'bold', width: 130 }}>Percentage (%)</TableCell>
                        <TableCell sx={{ fontWeight: 'bold', width: 80 }}>Action</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {payouts.map((payout) => {
                        const isSelected = selectedPayoutId === payout.id;
                        const pct = rowPercentages[payout.id] ?? '';
                        const pctNum = parseFloat(pct);
                        const isValid = pct !== '' && !isNaN(pctNum) && pctNum >= 0 && pctNum <= 100;
                        return (
                            <TableRow
                                key={payout.id}
                                onClick={() => onSelectPayout(payout.id)}
                                sx={{
                                    cursor: 'pointer',
                                    bgcolor: isSelected ? 'rgba(225,244,228,0.5)' : 'inherit',
                                    '&:hover': { bgcolor: isSelected ? 'rgba(225,244,228,0.7)' : '#f9f9f9' },
                                }}
                            >
                                <TableCell padding="checkbox">
                                    <input
                                        type="radio"
                                        readOnly
                                        checked={isSelected}
                                        style={{ cursor: 'pointer', accentColor: '#39B54A', width: 16, height: 16 }}
                                    />
                                </TableCell>
                                <TableCell>{payout.name}</TableCell>
                                <TableCell>{secondsToTime(payout.timeFrom)}</TableCell>
                                <TableCell>{secondsToTime(payout.timeTo)}</TableCell>
                                <TableCell>{payout.initialDistance ?? '-'}</TableCell>
                                <TableCell>{payout.initialDistanceCharge ?? '-'}</TableCell>
                                <TableCell>{payout.perKmCharge ?? '-'}</TableCell>
                                <TableCell onClick={(e) => e.stopPropagation()}>
                                    <input
                                        className="form-control"
                                        type="number"
                                        min={0}
                                        max={100}
                                        placeholder="0-100"
                                        value={pct}
                                        disabled={loading}
                                        onChange={(e) => {
                                            onSelectPayout(payout.id);
                                            onPercentageChange(payout.id, e.target.value);
                                        }}
                                        style={{ width: 100 }}
                                    />
                                </TableCell>
                                <TableCell onClick={(e) => e.stopPropagation()}>
                                    <button
                                        type="button"
                                        className="btn btn-sm"
                                        disabled={!isValid || loading || editingIndex !== null}
                                        onClick={() => onAdd(payout.id, pct)}
                                        style={{
                                            backgroundColor: isValid ? 'rgba(57,181,74,1)' : '#ccc',
                                            color: 'white',
                                            border: 'none',
                                            borderRadius: '4px',
                                            padding: '4px 12px',
                                            fontSize: '0.8rem',
                                        }}
                                    >
                                        Add
                                    </button>
                                </TableCell>
                            </TableRow>
                        );
                    })}
                </TableBody>
            </Table>
        </Box>
    );
}

export default PayoutSelectionTable;
